import { useEffect, useState } from 'react';
import styles from './HotpleModal.module.css';
import ReviewHotpleModal1 from './ReviewHotple/ReviewHotpleModal1';
import ReviewHotpleModal2 from './ReviewHotple/ReviewHotpleModal2';
import ReviewHotpleModal3 from './ReviewHotple/ReviewHotpleModal3';
import ReviewHotpleModal4 from './ReviewHotple/ReviewHotpleModal4';
import EditRequestHotpleModal from './EditRequestHotple/EditRequestHotpleModal';
import ImageEditHotpleModal from './ImageEditHotple/ImageEditHotpleModal';
import CorrectionRequestModal from './CorrectionRequest/CorrectionRequestModal';


const HotpleModal = ({hotpleModalPage, setHotpleModalPage, modalProps, updateHotpleInfo, account, marginTop}) => {
    const [editedHotple, setEditedHotple] = useState({});
    const [originalHotple, setOriginalHotple] = useState({});
    const [visible, setVisible] = useState(false);

    const goPrevPage = () => {
      if(hotpleModalPage==3 && (editedHotple.main_category=='음식점'||editedHotple.main_category=='주점'||editedHotple.main_category=='카페디저트'||editedHotple.main_category=='숙소'))
        setHotpleModalPage(hotpleModalPage-2);
      else
        setHotpleModalPage(hotpleModalPage-1);
    };

    const goNextPage = () => {
        setHotpleModalPage(hotpleModalPage+1);
    }

    const updateHotpleField = (key, value) => {
      setEditedHotple((prevHotple) => {
        return {
          ...prevHotple,
          [key]: value,
        };
      });
    };

    useEffect(() => {
      setVisible(true);
      /*
      setEditedHotple({
        ...modalProps.hotple,
        latitude: !modalProps.hotple.has_detail_address || modalProps.hotple.could_be_wrong ? null : modalProps.hotple.latitude,
        longitude: !modalProps.hotple.has_detail_address || modalProps.hotple.could_be_wrong ? null : modalProps.hotple.longitude,
      });
      */
      setEditedHotple({
        ...modalProps.hotple,
        latitude: modalProps.hotple.latitude,
        longitude: modalProps.hotple.longitude
      });
      setOriginalHotple(modalProps.hotple);
    }, []);

  	return (
        <div className={`${styles.modalbackground} ${visible ? styles.visible : ''}`}>
            <div className={`${styles.modalcontainer} ${visible ? styles.visible : ''}`}>
                {hotpleModalPage==1 &&<ReviewHotpleModal1 setHotpleModalPage={setHotpleModalPage} editedHotple={editedHotple} updateHotpleField={updateHotpleField} originalHotple={originalHotple} updateHotpleInfo={updateHotpleInfo} account={account} marginTop={marginTop}/>}
                {hotpleModalPage==2 &&<ReviewHotpleModal2 setHotpleModalPage={setHotpleModalPage} editedHotple={editedHotple} updateHotpleField={updateHotpleField} originalHotple={originalHotple} updateHotpleInfo={updateHotpleInfo} account={account} marginTop={marginTop}/>}
                {hotpleModalPage==3 &&<ReviewHotpleModal3 setHotpleModalPage={setHotpleModalPage} editedHotple={editedHotple} updateHotpleField={updateHotpleField} originalHotple={originalHotple} updateHotpleInfo={updateHotpleInfo} account={account} marginTop={marginTop}/>}
                {hotpleModalPage==4 &&<ReviewHotpleModal4 setHotpleModalPage={setHotpleModalPage} editedHotple={editedHotple} updateHotpleField={updateHotpleField} originalHotple={originalHotple} updateHotpleInfo={updateHotpleInfo} needCheck={!modalProps.is_verify} account={account} marginTop={marginTop}/>}

                {hotpleModalPage==11 &&<ReviewHotpleModal4 setHotpleModalPage={setHotpleModalPage} editedHotple={editedHotple} updateHotpleField={updateHotpleField} originalHotple={originalHotple} updateHotpleInfo={updateHotpleInfo} needCheck={!modalProps.is_verify} account={account} marginTop={marginTop}/>}
                {hotpleModalPage==12 &&<ReviewHotpleModal1 setHotpleModalPage={setHotpleModalPage} editedHotple={editedHotple} updateHotpleField={updateHotpleField} originalHotple={originalHotple} updateHotpleInfo={updateHotpleInfo} account={account} marginTop={marginTop}/>}
                {hotpleModalPage==13 &&<ReviewHotpleModal2 setHotpleModalPage={setHotpleModalPage} editedHotple={editedHotple} updateHotpleField={updateHotpleField} originalHotple={originalHotple} updateHotpleInfo={updateHotpleInfo} account={account} marginTop={marginTop}/>}
                {hotpleModalPage==14 &&<ReviewHotpleModal3 setHotpleModalPage={setHotpleModalPage} editedHotple={editedHotple} updateHotpleField={updateHotpleField} originalHotple={originalHotple} updateHotpleInfo={updateHotpleInfo} account={account} marginTop={marginTop}/>}

                {hotpleModalPage==21 &&<EditRequestHotpleModal setHotpleModalPage={setHotpleModalPage} editedHotple={editedHotple} updateHotpleField={updateHotpleField} originalHotple={originalHotple} updateHotpleInfo={updateHotpleInfo} account={account} marginTop={marginTop}/>}
                {hotpleModalPage==22 &&<ReviewHotpleModal1 setHotpleModalPage={setHotpleModalPage} editedHotple={editedHotple} updateHotpleField={updateHotpleField} originalHotple={originalHotple} updateHotpleInfo={updateHotpleInfo} account={account} marginTop={marginTop} isEditRequest={true}/>}
                {hotpleModalPage==23 &&<ReviewHotpleModal2 setHotpleModalPage={setHotpleModalPage} editedHotple={editedHotple} updateHotpleField={updateHotpleField} originalHotple={originalHotple} updateHotpleInfo={updateHotpleInfo} account={account} marginTop={marginTop} isEditRequest={true}/>}
                {hotpleModalPage==24 &&<ReviewHotpleModal3 setHotpleModalPage={setHotpleModalPage} editedHotple={editedHotple} updateHotpleField={updateHotpleField} originalHotple={originalHotple} updateHotpleInfo={updateHotpleInfo} account={account} marginTop={marginTop} isEditRequest={true}/>}

                {hotpleModalPage==31 &&<ImageEditHotpleModal setHotpleModalPage={setHotpleModalPage} editedHotple={editedHotple} updateHotpleField={updateHotpleField} originalHotple={originalHotple} updateHotpleInfo={updateHotpleInfo}/>}

                {hotpleModalPage==41 &&<CorrectionRequestModal setHotpleModalPage={setHotpleModalPage} editedHotple={editedHotple} updateHotpleField={updateHotpleField} originalHotple={originalHotple} updateHotpleInfo={updateHotpleInfo} marginTop={marginTop}/>}

                {hotpleModalPage > 1 && hotpleModalPage<10 &&
                    <div className={styles.backbutton} onClick={goPrevPage} style={marginTop!=0 ? {top: `${marginTop+12}px`} : {}}>
                        <img className={styles.iconcloseLine} alt="" src="images/back.svg" />
                    </div>
                }
                {hotpleModalPage!=31 &&
                  <div className={styles.closebutton} onClick={()=>setHotpleModalPage(0)} style={marginTop!=0 ? {top: `${marginTop+12}px`} : {}}>
                      <img className={styles.iconcloseLine} alt="" src="images/close_line.svg" />
                  </div>
                }
            </div>
        </div>
    );
};
    
export default HotpleModal;